import {
    bankTypeData
} from '@/api/card';
import {
    verificationInfo,
    bankList,
    moneyhistory
} from '@/api/money';
import store from '@/utils/store';

const actions = {
    // 银行卡类型列表
    bankTypeData(context) {
        store.loadCacheData(context, 'bankTypeData', bankTypeData);
    },
    // 车主认证信息
    verificationInfo(context, isReLoad = false) {
        store.loadCacheData(context, 'verificationInfo', verificationInfo, null, {
            isReLoad: isReLoad
        });
    },
    // 车主银行卡列表
    bankList(context, isReLoad = false) {
        store.loadCacheData(context, 'bankList', bankList, null, {
            mutationName: 'bankList',
            isReLoad: isReLoad
        });
    },
    // 最新提现记录
    moneyRecord(context, isReLoad = false) {
        store.loadCacheData(context, 'moneyRecord', moneyhistory, {
            pageSize: 1,
            current: 1
        }, {
            isReLoad: isReLoad
        });
    }
}
export default actions